import React from 'react';
import Box from '@amzn/awsui-components-console/box';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import ApplicationCard from './ApplicationCard';
import ApplicationCardSkeleton from './ApplicationCardSkeleton';
import EmptyState from '../common/EmptyState';
import type { UseCase } from '@amzn/aws-gcr-content-connection-management-client';
import './ApplicationsSection.scss';

export interface ApplicationsSectionProps {
  applications: UseCase[];
  loading: boolean;
  onApplicationClick: (id: string) => void;
}

const ApplicationsSection: React.FC<ApplicationsSectionProps> = ({ applications, loading, onApplicationClick }) => {
  // Calculate total subscriptions across all applications
  const totalSubscriptions = applications.reduce((sum, application) => sum + (application.subscribedCollections || []).length, 0);
  const applicationsCount = applications.length;

  return (
    <div className="applications-section">
      <SpaceBetween size="l">
        <Box textAlign="center">
          <h2 className="section-title">APPLICATIONS</h2>
          <p className="section-subtitle">
            Serve {applicationsCount} Core products, and support over {totalSubscriptions} subscribers.
          </p>
        </Box>

        {loading ? (
          <div className="applications-grid">
            {[...Array(9)].map((_, index) => (
              <ApplicationCardSkeleton key={index} />
            ))}
          </div>
        ) : applications.length === 0 ? (
          <EmptyState title="No applications found" description="There are no applications available at this time." icon="folder" />
        ) : (
          <div className="applications-grid">
            {applications.map((application) => (
              <ApplicationCard key={application.useCaseId} application={application} onClick={onApplicationClick} />
            ))}
          </div>
        )}
      </SpaceBetween>
    </div>
  );
};

export default ApplicationsSection;
